import { useRef } from "react";
import Camera from "../../.././assets/icons/maid-module-icons/Camera.svg";

const ImagePreview = ({ image, setImage }) => {
  const cameraRef = useRef(null);
  const galleryRef = useRef(null);

  const readFile = (file) => {
    if (!file || !file.type.startsWith("image/")) return;
    const reader = new FileReader();
    reader.onloadend = () => setImage(reader.result);
    reader.readAsDataURL(file);
  };

  return (
    <div style={{ position: "relative", width: 88, height: 88, flexShrink: 0 }}>
      {/* Hidden camera input */}
      <input
        ref={cameraRef}
        type="file"
        accept="image/*"
        capture="user"
        className="d-none"
        onChange={(e) => readFile(e.target.files[0])}
      />
      {/* Hidden gallery input */}
      <input
        ref={galleryRef}
        type="file"
        accept="image/*"
        className="d-none"
        onChange={(e) => readFile(e.target.files[0])}
      />

      {image ? (
        <>
          <img
            src={image}
            alt="preview"
            onClick={() => galleryRef.current?.click()}
            style={{
              width: 88,
              height: 88,
              borderRadius: "50%",
              objectFit: "cover",
              cursor: "pointer",
              
              border: "2px solid #e0e0e0",
            }}
          />
          {/* × remove button */}
          <button
            onClick={() => setImage(null)}
            style={{
              position: "absolute",
              top: 0,
              right: 0,
              width: 24,
              height: 24,
              borderRadius: "50%",
              border: "1.5px solid #ddd",
              background: "#fff",
              cursor: "pointer",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              fontSize: 14,
              color: "#000000",
              padding: 0,
              lineHeight: 1,
            }}
          >
            ×
          </button>
        </>
      ) : (
        <div
          onClick={() => cameraRef.current?.click()}
          style={{
            width: 88,
            height: 88,
            borderRadius: "50%",
            background: "#EAF2FF",
            cursor: "pointer",
            display: "flex",
          
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            gap: 4,
          }}
        >
          <img src={Camera} alt="camera" style={{ width: 24, height: 24 }} />
          <span style={{ fontSize: 9, color: "#3479B2", fontWeight: 500 }}>
            Capture Image
          </span>
        </div>
      )}
    </div>
  );
};

export default ImagePreview;